import {
  type FC,
  type ReactNode,
  type PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

const RGContext = createContext<any>(null);
export const useRGContext = () => {
  const context = useContext(RGContext);
  if (!context) {
    throw new Error('useRGContext must be used within a RGProvider');
  }
  return context;
};

const RGProvider: FC<PropsWithChildren<ReactNode>> = (props) => {
  const { children } = props;

  const [activeCompDimension, setActiveCompDimension] = useState({
    w: 1,
    h: 1,
  });

  const onDragStart = (dimension: { w: number; h: number }) => {
    setActiveCompDimension(dimension);
  };

  const onDragStop = () => {
    setActiveCompDimension({ w: 1, h: 1 });
  };

  return (
    <RGContext.Provider
      value={{
        activeCompDimension,
        onDragStart,
        onDragStop,
      }}
    >
      {children}
    </RGContext.Provider>
  );
};

export default RGProvider;
